// ลิงก์ลงทะเบียน (หน้าอีเวนต์ fengshuix.com) และช่องทางสอบถาม
export const REGISTER_URL =
  'https://www.fengshuix.com/event-details/serim-dwng-play-pi-2569-hiw-cea-phx-khea-hiy-keaasichang-cheuxm-phlang-mangkr-fea-khumthraphy-prathesthiy-1';
export const LINE_URL = 'https://lin.ee/l5066ST';

// ราคาตาม อ.แบ๊ท (25 ก.ย. 69): 9 ท่านแรก 6,000 · หลังจากนั้น 6,500 ถึง 15 พ.ย. 69 · ตั้งแต่ 16 พ.ย. 6,900 (ราคาเต็ม)
// เมื่อ 9 ที่แรกเต็ม ให้เปลี่ยนเป็น true แล้ว deploy ใหม่ (หน้าเว็บนับจำนวนคนสมัครเองไม่ได้)
export const FIRST_SEATS_SOLD_OUT = false;

const REGULAR_UNTIL = '2026-11-15';
const TRIP_DATE = '2026-11-19';

export const TIERS = [
  { key: 'first9', price: 6000, badge: 'เฉพาะ 9 ท่านแรก', line: 'เฉพาะ 9 ท่านแรก 6,000 บาท' },
  { key: 'regular', price: 6500, badge: 'ถึง 15 พ.ย. 69', line: 'หลังจากนั้น 6,500 บาท · ถึง 15 พ.ย. 69' },
  { key: 'full', price: 6900, badge: 'ราคาเต็ม', line: 'ตั้งแต่ 16 พ.ย. 69 · 6,900 บาท (ราคาเต็ม)' },
];

const todayBangkok = () =>
  new Date(Date.now() + 7 * 60 * 60 * 1000).toISOString().slice(0, 10);

// -1 = ปิดรับแล้ว (ถึงวันเดินทาง)
export const getCurrentTierIndex = () => {
  const today = todayBangkok();
  if (today >= TRIP_DATE) return -1;
  if (today > REGULAR_UNTIL) return 2;
  return FIRST_SEATS_SOLD_OUT ? 1 : 0;
};

export const formatBaht = (n) => n.toLocaleString('en-US');

export const getHeadline = () => {
  const index = getCurrentTierIndex();
  if (index < 0) return null;
  const tier = TIERS[index];
  return `฿${formatBaht(tier.price)} ${tier.badge}`;
};

export const getNextHint = () => {
  const index = getCurrentTierIndex();
  if (index === 0) return 'เมื่อครบ 9 ท่านแรก ราคาปรับเป็น 6,500 บาท';
  if (index === 1) return 'ตั้งแต่ 16 พ.ย. 69 ราคาปรับเป็น 6,900 บาท (ราคาเต็ม)';
  if (index === 2) return 'ราคาเต็ม · ทริปวันที่ 19 พ.ย. 69';
  return 'ขอบคุณทุกท่านที่ให้ความสนใจ';
};
